<template>
  <div v-show="images.length > 0" class="c-category__thumb">
    <div ref="is-wrap" class="is-wrap">
      <div class="is-wrap-image">
        <div ref="image" v-for="img in images" 
             :style="{'visibility':'hidden', 'backgroundImage': `url(${img})`, 'backgroundSize': 'cover', 'backgroundPosition': 'center center'}"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap, Quart } from 'gsap';

export default {
  props: ['category', 'max'],
  data() {
    return {
      isStart: false,
      images: [],
      current: 0,
      zIndex: 1,
      timer: null,
    }
  },
  computed: {
  },
  mounted() {
    for (let i = 1; i <= this.max; i++) {
      this.images.push(`${this.$store.getters.assetsPath}img/top/${this.category}/thumb${i}.jpg`);
    }
    this.$nextTick(this.once);
  },
  methods: {
    once() {
      this.$refs['image'][this.current].style.visibility = 'visible';
    },
    start() {
      if (this.isStart) return;
      this.isStart = true;
      this.timer = setTimeout(this.changeImage, 3000);
    },
    changeImage() {
      const next = (this.current + 1) % this.max;
      this.zIndex++;

      // 表示
      gsap.fromTo(this.$refs['image'][next], {
        visibility: 'visible',
        clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)',
        zIndex: this.zIndex,
      }, {
        duration: 0.7,
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        ease: Quart.easeInOut,
        onCompleteParams: [next],
        onComplete: this.changeImageComp,
      });
    },
    changeImageComp(next) {
      this.$refs['image'][this.current].style.visibility = 'hidden';
      this.current = next;
      this.timer = setTimeout(this.changeImage, 4000);
    },
    reset() {
      this.$refs['image'].forEach((el) => {
        gsap.killTweensOf(el);
      });
      clearTimeout(this.timer);
    }
  }
}
</script>